import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Observable, from, throwError } from 'rxjs'
import { Injectable } from '@angular/core'
import { catchError, map, switchMap } from 'rxjs/operators'
import { ModalController } from '@ionic/angular/standalone'
import { ErrorModalComponent } from './error-modal/error-modal.component'
import { OAuthService } from 'angular-oauth2-oidc'
import { ErrorResponseDTO } from './error-response.model'


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(
        private modalController: ModalController,
        private oauthService: OAuthService
    ) {
    }

    async extractErrorBody(error: any): Promise<ErrorResponseDTO> {
        if (error?.error instanceof Blob) {
            try {
                const text = await error.error.text()
                return JSON.parse(text)
            } catch {
                return { message: error?.statusText }
            }
        }
        return error?.error
    }

    triggerLogin() {
        this.oauthService.logOut(true);
        this.oauthService.stopAutomaticRefresh();
        window.location.reload();
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
        return next.handle(req).pipe(
            map((resp) => {
                return resp;
            }),
            catchError((error) => {
                console.error(error)
                // Se ho ricevuto errori in fase di refresh token o revoca token vuol dire che il token è scaduto quindi faccio logout
                if (req.url.indexOf('openid-connect/revoke') === -1 && req.url.indexOf('openid-connect/token') === -1) {
                    return from(this.extractErrorBody(error)).pipe(
                        switchMap((errorBody) => {
                            let targetError: ErrorResponseDTO = errorBody
                            if (error?.status === 401) {
                                targetError = {
                                    message: error?.statusText,
                                }
                                this.triggerLogin()
                            } else if (error?.status === 403) {
                                targetError = {
                                    message: error?.statusText,
                                }
                            }
                            this.modalController.create({
                                component: ErrorModalComponent,
                                cssClass: 'custom-modal',
                                componentProps: {
                                    error: targetError
                                }
                            }).then((m) => {
                                m.present()
                            })
                            return throwError(new HttpErrorResponse(error));
                        })
                    )
                } else {
                    if (req.url.indexOf('openid-connect/revoke') === -1) {
                        try {
                            this.oauthService.revokeTokenAndLogout(null, true).then((res) => {
                                this.triggerLogin();
                            }).catch((res) => {
                                this.triggerLogin();
                            });
                        } catch (error){
                            console.error(error)
                            this.triggerLogin();
                        }
                    } else {
                        this.triggerLogin();
                    }
                }
            })
        );
    }
}
